import {get} from 'lodash';

export const setIsLoading = (
  state = {},
  {
    searchInput,
    status,
    filterParam = 'default',
    sortBy = '',
    sortOrder = '',
  }: any,
) => ({
  ...state,
  allSearchMeta: {
    ...get(state, 'allSearchMeta', {}),
    [`${searchInput}-${sortBy}-${sortOrder}-${filterParam}`]: {
      ...get(
        state,
        `allSearchMeta.${searchInput}-${sortBy}-${sortOrder}-${filterParam}`,
        {},
      ),
      isLoading: status,
    },
  },
});
